import { render } from "./QuoteCard.vue?vue&type=template&id=e33ef628"
import script from "./QuoteCard.vue?vue&type=script&lang=js"
export * from "./QuoteCard.vue?vue&type=script&lang=js"

import "./QuoteCard.vue?vue&type=style&index=0&id=e33ef628&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__